import { QueryClient } from '@tanstack/react-query';

// Shared React Query client. staleTime keeps recently fetched data usable across
// route remounts (so navigating back renders instantly from cache instead of
// flashing a loading spinner), while background refetches keep it fresh.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1
    }
  }
});
